export var FieldOverride;
(function (FieldOverride) {
    FieldOverride["YesNo"] = "YesNo";
    FieldOverride["BusinessSizeComponent"] = "BusinessSizeComponent";
    FieldOverride["BusinessConcepts"] = "BusinessConcepts";
})(FieldOverride || (FieldOverride = {}));
